document.addEventListener('DOMContentLoaded', function () {
  // Get product ID from variant-picker
  const variantPicker = document.querySelector('variant-picker');
  if (!variantPicker) {
    console.log('Element <variant-picker> not found. Script not running (likely on product list page).');
    return;
  }

  const productId = variantPicker.getAttribute('data-product-id');
  if (!productId) {
    console.error('Product ID not found in variant-picker data attribute.');
    return;
  }

  // Function to update sale percentage
  function updateSalePercentage(variant) {
    const saleOffElements = document.querySelectorAll(`.sale-off-percentage-${productId}`);
    try {
      const currentPrice = parseFloat(variant.price) / 100; // Convert from cents to USD
      const compareAtPrice = variant.compare_at_price ? parseFloat(variant.compare_at_price) / 100 : null;

      if (compareAtPrice && compareAtPrice > currentPrice) {
        const salePercentage = Math.round(((compareAtPrice - currentPrice) / compareAtPrice) * 100);
        saleOffElements.forEach(el => {
          el.textContent = `${salePercentage}% Off`;
          el.style.display = 'inline';
        });
      } else {
        saleOffElements.forEach(el => {
          el.textContent = '';
          el.style.display = 'none';
        });
      }
    } catch (error) {
      console.error('Error calculating sale percentage:', error);
    }
  }

  // Function to wait for productVariants element
  function waitForProductVariants(callback) {
    const maxAttempts = 10;
    let attempts = 0;

    const checkElement = setInterval(() => {
      const variantDataElement = document.getElementById('productVariants');
      if (variantDataElement) {
        clearInterval(checkElement);
        callback();
      } else if (attempts >= maxAttempts) {
        clearInterval(checkElement);
        console.error(`Element "productVariants" not found after ${maxAttempts} attempts.`);
      }
      attempts++;
    }, 500); // Check every 500ms
  }

  // Initialize variant picker
  function initializeVariantPicker() {
    // Listen for radio button change event
    variantPicker.addEventListener('change', function (event) {
  if (event.target.type === 'radio') {
    const variantDataElement = document.getElementById('productVariants');
    if (!variantDataElement) {
      console.error('Element "productVariants" not found.');
      return;
    }

    try {
      const variants = JSON.parse(variantDataElement.textContent);

      // Lấy tất cả lựa chọn hiện tại
      const selectedOptions = {};
      variantPicker.querySelectorAll('input[type="radio"]:checked').forEach(input => {
        selectedOptions[input.name] = input.value;
      });

      console.log('Selected options:', selectedOptions);

      // Tìm variant khớp với tất cả option
      const selectedVariant = variants.find(variant => {
        return Object.values(selectedOptions).every((val, idx) => variant[`option${idx+1}`] === val);
      });

      if (selectedVariant) {
        updateSalePercentage(selectedVariant);
      } else {
        console.error('Variant not found for selected options:', selectedOptions);
      }
    } catch (error) {
      console.error('Error parsing variants JSON:', error);
    }
  }
});

    // Listen for AJAX variant:changed event
    document.addEventListener('variant:changed', function (event) {
      const selectedVariant = event.detail.variant;
      if (selectedVariant && selectedVariant.option1) {
        console.log('Variant changed via AJAX to:', selectedVariant.option1);
        updateSalePercentage(selectedVariant);
      }
    });
  }

  // Run after productVariants element is available
  waitForProductVariants(initializeVariantPicker);
});